import { useEffect, useState } from "react";
import { message, Modal } from "antd";
import useUsers from "@hooks/useUsers";
import { fetchNotification, readNotification } from "@services/common";

const { confirm } = Modal;
export default () => {
  const { getUserInfoFromLocal } = useUsers();
  const { realm_user_id } = getUserInfoFromLocal();
  const [windowHeight, setWindowHeight] = useState<number>(window.innerHeight);

  const fetchData = async () => {
    const resp = await fetchNotification(realm_user_id || 0);
    if (!resp.result) {
      return;
    }
    const { object: data } = resp;
    if (data.length === 0) {
      return;
    }
    for (let i = 0; i < data.length; i += 1) {
      setTimeout(() => {
        confirm({
          title: data[i].title,
          mask: i === 0,
          content: (
            <div
              dangerouslySetInnerHTML={{ __html: data[i].content }}
              style={{
                height: `${windowHeight * 0.7}px`,
                overflow: "auto",
              }}
            />
          ),
          onOk() {
            return new Promise((resolve, reject) => {
              handleRead(data[i].id).then((resp) => {
                resp ? resolve(null) : reject();
              });
            });
          },
          width: 600,
          centered: true,
          cancelButtonProps: { style: { display: "none" } },
        });
      }, i * 500);
    }
  };

  const handleRead = async (id: number) => {
    const resp = await readNotification(id);
    if (!resp.result) {
      message.error("read state update failed");
      return false;
    }
    return true;
  };

  useEffect(() => {
    fetchData().catch((err) => console.warn(err));
  }, []);

  return <></>;
};
